module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_VCNC_m2.6e1755b2304d73202941c972f920935a.png";